import { render, staticRenderFns } from "./RFundsPop.vue?vue&type=template&id=15fdc3cd&"
import script from "./RFundsPop.vue?vue&type=script&lang=js&"
export * from "./RFundsPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports